import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/views/auth/Home.vue';
import Personeel from '@/views/auth/Personeel.vue';
import Login from '@/views/Login.vue';
import Signup from '@/views/Signup.vue';
import Register from '@/views/Register.vue';
import Noaccess from '@/views/Noaccess.vue';
import News from '@/views/auth/News';
import Documents from '@/views/auth/Documents';
import Calendar from '@/views/auth/calendar/Calendar';
//import Dashboard from '@/components/Dashboard'
import Employees from '@/views/auth/Employees'
import ViewEmployee from '@/components/ViewEmployee'
//import EditEmployee from '@/components/EditEmployee'
import NewEmployee from '@/components/NewEmployee'
import NewInfoItem from '@/views/auth/NewInfoItem.vue'
import ViewItem from '@/views/auth/ViewItem.vue'
import NewDocument from '@/views/auth/NewDocument.vue'
import NewEvent from '@/views/auth/calendar/NewEvent.vue'
import Establishments from '@/views/auth/settings/Establishments.vue'
import Notifications from '@/views/auth/notifications/Notifications.vue'
import NewNotification from '@/views/auth/notifications/NewNotification.vue'

import firebase from 'firebase';


Vue.use(VueRouter);

const routes = [{
        path: '*',
        redirect: '/login'
    },
    {
        path: '/',
        redirect: '/home'
    },
    {
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
        path: '/signup',
        name: 'Signup',
        component: Signup
    },
    {
        path: '/register',
        name: 'Register',
        component: Register
    },
    {
        path: '/noaccess',
        name: 'Noaccess',
        component: Noaccess,
    },
    // authenticate needed routes
    {
        path: '/home',
        name: 'Home',
        component: Home,
        meta: {
            requiresAuth: true
        }
    },
    // {
    //     path: '/dashboard',
    //     name: 'dashboard',
    //     component: Dashboard,
    //     meta: {
    //         requiresAuth: true
    //     }
    // },
    {
        path: '/employees',
        name: 'employees',
        component: Employees,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/personeel',
        name: 'Personeel',
        component: Personeel,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/new-employee/:id',
        name: 'new-employee',
        component: NewEmployee,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/view-employee/:employee_id',
        name: 'view-employee',
        component: ViewEmployee,
        meta: {
            requiresAuth: true
        }
    },
    // {
    //     path: '/edit-employee/:employee_id',
    //     name: 'edit-employee',
    //     component: EditEmployee,
    //     meta: {
    //         requiresAuth: true
    //     }
    // },
    {
        path: '/news',
        name: 'News',
        component: News,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/view-item/:cid/:id',
        name: 'view-item',
        component: ViewItem,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/new-info-item/:id',
        name: 'new-info-item',
        component: NewInfoItem,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/notifications',
        name: 'Notifications',
        component: Notifications,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/new-notification',
        name: 'new-notification',
        component: NewNotification,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/documents',
        name: 'Documents',
        component: Documents,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/new-document/:id',
        name: 'new-document',
        component: NewDocument,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/calendar',
        name: 'Calendar',
        component: Calendar,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/new-event/:id',
        name: 'new-event',
        component: NewEvent,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/establishments',
        name: 'Establishments',
        component: Establishments,
        meta: {
            requiresAuth: true
        }
    },
];

const router = new VueRouter({
    mode: 'history',
    routes
});

router.beforeEach(
    (to, from, next) => {
        const currentUser = firebase.auth().currentUser;
        const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
        if (requiresAuth && !currentUser) next('login');
        //   else if (!requiresAuth && currentUser) next('home');
        else next();
    }
);

export default router;